import React from 'react';
import ErrorBoundary from './error-boundary';

/**
 *     Error boundary HOC
 *     wrap a component to catch all JS errors and display a fallback
 */

type ComponentType<T> = React.ComponentClass<T> | React.StatelessComponent<T>;

interface ErrorBoundaryHOCProps {}

function withErrorBoundaryHOC<ComponentProps extends {}>(Component: ComponentType<ComponentProps>) {
    type MergedProps = ComponentProps & ErrorBoundaryHOCProps;

    class ErrorBoundaryHOC extends React.Component<MergedProps> {
        static displayName = `ErrorBoundaryHOC(${Component.displayName || Component.name})`;

        render() {
            return (
                <ErrorBoundary {...(this.props as any)}>
                    <Component {...(this.props as any)} />
                </ErrorBoundary>
            );
        }
    }

    return ErrorBoundaryHOC;
}

export default withErrorBoundaryHOC;
